import { useCallback } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";
import { useProject } from "../context/ProjectContext.tsx";
import { useMechanicsConfiguration } from "../context/MechanicsConfigurationContext.tsx";
import { useElectronicsConfiguration } from "../context/ElectronicsConfigurationContext.tsx";
import { useTestProcedure } from "../context/TestProcedureContext.tsx";

export const useEncodeBinary = () => {
  const { handle } = useMessageHandler();
  const { project } = useProject();
  const { config: mechanics } = useMechanicsConfiguration();
  const { config: electronics } = useElectronicsConfiguration();
  const { procedures: testProcedures } = useTestProcedure();

  const encode = useCallback(async (): Promise<Blob | null> => {
    if (!mechanics || !electronics || !project || !testProcedures) return null;

    const data = {
      project,
      mechanics,
      electronics,
      testProcedures
    };
    return await handle(async () => {
      const response = await apiJson.post("/binary/encode", data, {
        responseType: "blob",
      });
      return response.data as Blob;
    }).catch(() => null);
  }, [handle, project, mechanics, electronics, testProcedures]);

  return { encode };
};
